import React from 'react';

export default function Author(props) {
    return (
        <span className="author">
            {props.node.email !== '' ? <a href={`mailto:${props.node.name}`}>{props.node.firstName} {props.node.lastName}</a> : <span>{props.node.firstName} {props.node.lastName}</span>}        
        </span>
    );
}